import { selectorFamily } from 'recoil';
import { allCoverablesOnsaAtom } from '../atoms/allCoverablesOnsaAtom';
import { allCoverablesAtom } from '../atoms/allCoverablesAtom';

export const numberOfFlavourCoverablesSelector = selectorFamily({
    key: 'numberOfFlavourCoverables',
    get:
        (flavourName: string) =>
        ({ get }) => {
            const allCoverablesOnsa = get(allCoverablesOnsaAtom);
            const allCoverables = get(allCoverablesAtom);
            const allFlavourCoverables = Object.values(allCoverables)
                .flat()
                .filter(
                    (coverable) =>
                        coverable.flavourName === flavourName &&
                        coverable.status === 'Added' &&
                        coverable.isAddedInOnsa
                );

            const allFlavourCoverablesOnsa = Object.values(allCoverablesOnsa)
                .flat()
                .filter(
                    (coverable) =>
                        coverable.flavourName === flavourName &&
                        (coverable.yearlyPrice || coverable.monthlyPrice) &&
                        coverable.isAddedInOnsa
                );

            const numbOfFlavourCoverables = allFlavourCoverables.length;
            const numbOfFlavourCoverablesOnsa = allFlavourCoverablesOnsa.length;
            return numbOfFlavourCoverables + numbOfFlavourCoverablesOnsa;
        }
});
